import React, { useState } from 'react';
import '../../scss/login.scss';
import eyeicon from '../../images/login/eyeicon.png';
import bluebackground from '../../images/login/blubackground.jpg';
import getCommonResponse from '../actions/Common';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { parseUserName } from '../../store/Actions'
import { parseUserId } from '../../store/Actions'
import { parseUserlogo, parseUserRole } from '../../store/Actions'
import { parseNotification } from '../../store/Actions'
import { parseConnection } from '../../store/Actions'
import { parseEmail } from '../../store/Actions'
import { HubConnectionBuilder, HttpTransportType } from '@microsoft/signalr';
import Cookies from 'js-cookie'
import getProfile from '../actions/Profile';
import Signal from '../actions/Signal';
import Snackbars from '../Reusables/Snackbar';
import clairvoyix from '../../images/project/clairvoyix-image.gif'

function Login(props) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    console.log("location", location);
    const dispatch = useDispatch();
    const SIGNALR_URL = Signal();
    const [open, setOpen] = useState(null)
    function Toggle() {
        if(document.getElementsByClassName('password')[0].type === 'password') {
            document.getElementsByClassName('password')[0].type = 'text';
        }
        else {
            document.getElementsByClassName('password')[0].type = 'password'
        }
    }
    function LoginNavigate() {
        dispatch(parseNotification(''));

        const URL = '/api/users/login';
        let data = {
            UserName : email,
            Password : password
        }
        getCommonResponse.GetLogin(URL, data, (response) => {
            if(response.status === 200) {
                const accessToken = response.data.accessToken;
                const refreshToken = response.data.data.refreshToken;
                Cookies.set('access_token', accessToken);
                Cookies.set('refresh_token', refreshToken)

                if(response.data.data.firstName !== '' && response.data.data.firstName !== undefined && response.data.data.firstName !== null) {
                    var firstName = response.data.data.firstName;
                } else {
                    var firstName = '';
                }

                if(response.data.data.lastName !== '' && response.data.data.lastName !== undefined && response.data.data.lastName !== null) {
                    var lastName = response.data.data.lastName;
                } else {
                    var lastName = '';
                }

                var name = firstName +' '+lastName;
                dispatch(parseUserName(name));
                var id = response.data.data.id;
                var url = response.data.data.profileUrl
                dispatch(parseUserlogo(url))

                if(id) {
                    getProfile.ProfileInfo(`/api/users/info?userId=${id}`, accessToken, (data)=> {
                        if(data.status == 200) {
                            const response = data.data.data;
                            dispatch(parseUserRole(response.selectedRoles[0].idRoles))
                        } else if(data.status == 401) {
                            navigate("/login")
                        }
                    })  
                }
                dispatch(parseUserId(id));

                var email = response.data.data.email;
                dispatch(parseEmail(email));

                const access_token = Cookies.get('access_token');
                console.log("logintoken", access_token);

                if(location.state) {
                    navigate(location.state.path);  
                }
                else {
                    navigate('/projects/list?category=Active');
                }
                //SignalR
                const newConnection = new HubConnectionBuilder()
                    .withUrl(`${SIGNALR_URL}/uploadchat`, {
                    accessTokenFactory: () => accessToken,
                    skipNegotiation: true,
                    transport: HttpTransportType.WebSockets
                })
                .withAutomaticReconnect()
                .build();
                console.log("[LoginSignalRlogin]", newConnection);
                dispatch(parseConnection(newConnection));
                
                // Receiving the response
                newConnection.on("Notification", function (user, message) {
                    // We can assign user-supplied strings to an element's textContent because it
                    // is not interpreted as markup. If you're assigning in any other way, you 
                    // should be aware of possible script injection concerns.
                    console.log("[LoginSignalR] RECEIVING... ", user, message)
                    dispatch(parseNotification(message));
                });

                // Connection start
                newConnection.start().then(function () {
                    console.log("[LoginSignalR] Receiving ...");
                }).catch(function (err) {
                    return console.error(err.toString());
                });
            }
            if((response.status === 404) || (response.status === 400)) {
                setOpen(true);
                setError(response.data.message);
            }
        });
    }

    const NavigateForgotPassword = () => {
        navigate('/forgot-password')
    }

    return (
        <div className='login-container'>
            <div className='login-left-section'>
                <div className='bluebackground-section'>
                    <img className='bg-img' src={bluebackground} alt="bluebackground"></img>
                </div>
                <div className='clairvoyix-logo'>
                    <img src={clairvoyix} alt='clairvoyixlogo'></img>
                    <div className='logo-title'>Control Center</div>
                </div>
            </div>
            <div className='login-right-section'>
                <div className='login-content'>
                    <Snackbars error={error} open={open} setOpen={setOpen}/>
                    <h1>Login To Your Account</h1>
                    <div className='email-container email-password'>
                        <input type='email' name='email' className='email' placeholder='Email' onChange={(e) => setEmail(e.target.value)}></input>
                    </div>
                    <div className='password-container email-password'>
                        <input type='password' name='password' className='password' placeholder='Password' onChange={(e) => setPassword(e.target.value)}></input>
                        <img src={eyeicon} alt="eye-icon" onClick={Toggle}></img>
                    </div>
                    <button className="login-button" onClick={LoginNavigate}>LOGIN</button>
                    <p onClick={NavigateForgotPassword}>Forgot Password</p>
                </div>   
            </div>
        </div>
    );
}

export default Login;